import {
  createSlice
} from '@reduxjs/toolkit';

export const tmpWishes = createSlice({
  name: 'tmpWishes',
  initialState: {
    data: ['beforeFetch']
  },
  reducers: {
    fetchSuccess: function (state, action) {
      const {
        payload
      } = action;
      state.data = payload;
    },
  },
}).reducer;